<template>
  <div class="error">
      <div class="margin-general">
          <div class="content_main">
              <div class="conten_info">
                  <div class="text">
                      <span class="material-symbols-outlined" translate="no">sentiment_dissatisfied</span>
                      <h2>{{ $t('error.title') }}</h2>
                      <p class="body-6">{{ $t('error.descript') }}</p>
                  </div>
                  <div class="btn">
                      <NuxtLink :to="localPath('/')">
                          <button class="primary-button-medium">
                              {{ $t('error.home') }}
                          </button>
                      </NuxtLink>
                      <NuxtLink :to="localPath('/contact-us/')">
                          <button class="second-button-medium">
                              {{ $t('error.contact') }}
                          </button>
                      </NuxtLink>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const localPath = useLocalePath();

const { t } = useI18n();

const props = defineProps({
  error: Object
});

const title = computed(() => {
  if (props.error.statusCode === 404) {
    return t('seo.404.title');
  }
  if (props.error.statusCode === 410) {
    return t('seo.410.title');
  }
});

const description = computed(() => {
  if (props.error.statusCode === 404) {
    return t('seo.404.description');
  }
  if (props.error.statusCode === 410) {
    return t('seo.410.description');
  }
});

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  robots: 'noindex'
});
</script>